var _style, _defs, _polygon, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.4 237",
    style: {
      enableBackground: "new 0 0 469.4 237"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000179627577568949876630000007364991175342637755_);}\n\t.st1{opacity:0.5045;fill:#F2F2F2;}\n\t.st2{opacity:0.9;enable-background:new    ;}\n\t.st3{clip-path:url(#SVGID_00000120541309037837934690000001695215773839815826_);}\n\t.st4{clip-path:url(#SVGID_00000049912846476522751840000008027462339169374137_);fill:#191847;}\n\t.st5{clip-path:url(#SVGID_00000158006358470649178070000004957533637558775190_);}\n\t.st6{clip-path:url(#SVGID_00000005231836466903912120000009843873704545396648_);fill:#B28B67;}\n\t.st7{clip-path:url(#SVGID_00000153692097088644610970000003586316423847744404_);}\n\t.st8{clip-path:url(#SVGID_00000031909571317721078700000012824236420912969346_);fill:#191847;}\n\t.st9{clip-path:url(#SVGID_00000044874237346929621080000008235134779177900968_);}\n\t.st10{clip-path:url(#SVGID_00000148633721875630574430000006149329516068603826_);fill:#997659;}\n\t.st11{clip-path:url(#SVGID_00000053537462854540237580000015552740608896095922_);}\n\t.st12{clip-path:url(#SVGID_00000047781831823378827130000010521479206564564364_);fill:#B28B67;}\n\t.st13{clip-path:url(#SVGID_00000036967300250377698590000016074465328675813008_);}\n\t.st14{clip-path:url(#SVGID_00000004522134991070585740000007226143807087588273_);fill:#E4E4E4;}\n\t.st15{clip-path:url(#SVGID_00000087410613835827953940000000501475823747807132_);}\n\t.st16{clip-path:url(#SVGID_00000168818842969149295690000014168476666727606689_);fill:#E4E4E4;}\n\t.st17{clip-path:url(#SVGID_00000178904782461371767580000018327409731573108617_);}\n\t.st18{clip-path:url(#SVGID_00000091003136389774748640000010405501576751969452_);fill:#69A1AC;}\n\t.st19{clip-path:url(#SVGID_00000107557760271012280960000000054911028861339547_);}\n\t.st20{clip-path:url(#SVGID_00000062175437374516446790000010429497282967225501_);fill:#89C5CC;}\n\t.st21{clip-path:url(#SVGID_00000170968493818579846430000004714085175551437755_);}\n\t.st22{clip-path:url(#SVGID_00000064342614208979750560000016298356353857577622_);fill:#997659;}\n\t.st23{clip-path:url(#SVGID_00000055696426168422684290000000301039977515504565_);}\n\t.st24{clip-path:url(#SVGID_00000121965334202094113830000005771837707455721370_);fill:#2026A2;}\n\t.st25{clip-path:url(#SVGID_00000052077265596980648600000002366301378359038382_);}\n\t.st26{clip-path:url(#SVGID_00000047745022047285555580000001732298482882534841_);fill:#1F28CF;}\n\t.st27{opacity:0.7;enable-background:new    ;}\n\t.st28{clip-path:url(#SVGID_00000034795634127865974930000012026934511702077616_);}\n\t.st29{clip-path:url(#SVGID_00000126298779069694892650000002194975157703429304_);fill:#69A1AC;}\n\t.st30{clip-path:url(#SVGID_00000158741953887086938480000018264743813593216679_);}\n\t.st31{clip-path:url(#SVGID_00000034054827525676352430000012344749709565305258_);fill:#89C5CC;}\n\t.st32{clip-path:url(#SVGID_00000167389509369940459520000013800002462463969433_);}\n\t.st33{clip-path:url(#SVGID_00000051376317850586765250000011165061174211186569_);fill:#89C5CC;}\n\t.st34{clip-path:url(#SVGID_00000018230219599291872440000014836897620518720412_);}\n\t.st35{clip-path:url(#SVGID_00000014605477761626405520000010407513653343747213_);fill:#89C5CC;}\n\t.st36{clip-path:url(#SVGID_00000071555309811665486730000012045807091783285935_);}\n\t.st37{clip-path:url(#SVGID_00000101817212467635109320000002661958940383641786_);fill:#69A1AC;}\n\t.st38{clip-path:url(#SVGID_00000102504863353172126570000014049982975771182253_);}\n\t.st39{clip-path:url(#SVGID_00000166670308947637800100000017600842453231523230_);fill:#F2F2F2;}\n\t.st40{clip-path:url(#SVGID_00000054253035651868179870000003915113638284524977_);}\n\t.st41{clip-path:url(#SVGID_00000150072757911782034560000001278682370636817810_);fill:#F2F2F2;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M506.8,147.7c7.4,55.3-171.8,91.3-326.1,66.2S-44.4,90.4,29.2,38.1S499.4,92.4,506.8,147.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016780674651758868680000013477897275128973184_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016780674651758868680000013477897275128973184_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,0 469.4,0 469.4,237 0,237  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003100628495480609630000006926296188257478281_",
    d: "M264.9,36.3c-6.4,0-8.7-7.6-12.3-11.8 c-2.6-3-7-2.1-8.3-6.3c-3.3-10.5,5.5-18,17-18c11.5,0,19.3,6.5,21,16.3C283.9,26.3,276.4,36.3,264.9,36.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072979328259825503090000000766278897579486886_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003100628495480609630000006926296188257478281_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072979328259825503090000000766278897579486886_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155130653153973002760000008041376018516947331_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091718991944880948830000015779552111782510214_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155130653153973002760000008041376018516947331_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 239.9,
    y: -0.8,
    style: {
      clipPath: "url(#SVGID_00000091718991944880948830000015779552111782510214_)",
      fill: "#191847"
    },
    width: 45,
    height: 38.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008111695893454588380000006451682217693054880_",
    d: "M247.5,15.4c-3.2,6-2.9,21.3,1.3,22.4 c1.7,0.4,5.2-0.6,8.8-2.8l-2.3,16h13.4l-4.6-21.5c2.6-3,4.3-6.7,4-10.9C267.4,6.7,250.7,9.4,247.5,15.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046330868951625445790000002662370384528936118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008111695893454588380000006451682217693054880_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000046330868951625445790000002662370384528936118_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000081643732379954487930000007607829003990150842_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013909867039333318440000017646430593211917698_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081643732379954487930000007607829003990150842_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 243.3,
    y: 5.7,
    style: {
      clipPath: "url(#SVGID_00000013909867039333318440000017646430593211917698_)",
      fill: "#B28B67"
    },
    width: 26.6,
    height: 46.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160883980599925076130000009582526725268540606_",
    d: "M246.7,15.4c2.6,0.5,7.7,2.9,11.8,6.4 c0.5-0.3,1-0.4,1.6-0.4c1.9,0,3.4,1.5,3.4,3.3c0,0.8-0.3,1.5-0.7,2c0.8,1.3,1.4,2.7,1.6,4.2c2.8,0,13.1-10.7,2.9-20.7 C257.1,0.2,242.2,14.6,246.7,15.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119077769484908253450000015984187009855451060_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160883980599925076130000009582526725268540606_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119077769484908253450000015984187009855451060_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000079448055994245170640000000306488858074780829_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085954391790856381750000003905107576023071678_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079448055994245170640000000306488858074780829_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: -0.7,
    style: {
      clipPath: "url(#SVGID_00000085954391790856381750000003905107576023071678_)",
      fill: "#191847"
    },
    width: 37.4,
    height: 32.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000153680280334905869860000009322112176234476192_",
    points: "272.7,98 251.8,166.5 241.7,224.7  233.7,224.7 244.4,98  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094610544073910533760000006119757963591017133_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153680280334905869860000009322112176234476192_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094610544073910533760000006119757963591017133_)"
    }
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000125562026475476881510000014153000657400000901_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119822491689740904660000012957812016614586269_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125562026475476881510000014153000657400000901_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 232.7,
    y: 97,
    style: {
      clipPath: "url(#SVGID_00000119822491689740904660000012957812016614586269_)",
      fill: "#997659"
    },
    width: 41.1,
    height: 128.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000180347880904521587460000008686866594963263632_",
    d: "M280.2,98c-1.4,37.6,0.3,57,0.6,60.4 c0.3,3.4,4.7,25.6,15,67.4l-8.5-2.9c-16.3-38.4-21.9-58.4-23.7-63.4c-1.9-5-6.8-25.5-14.9-61.5H280.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107589695199242547600000012502684992844923289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180347880904521587460000008686866594963263632_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107589695199242547600000012502684992844923289_)"
    }
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119085275946907466100000008812891860154951581_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147189773067022915510000016127150200794463927_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119085275946907466100000008812891860154951581_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 97,
    style: {
      clipPath: "url(#SVGID_00000147189773067022915510000016127150200794463927_)",
      fill: "#B28B67"
    },
    width: 49.1,
    height: 129.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000091708321662076898740000014340713045811718576_",
    d: "M296.1,223.8c0.4,1.2,0.6,2.1,0.6,2.8 c0,1-0.2,2.5-0.5,4.4c-1.2,0-11.6,0-31.4,0c-0.8-2.7-0.3-4.2,1.4-4.4c1.8-0.2,3.2-0.4,4.4-0.6l14.2-6.3c0.5-0.2,1.1,0,1.3,0.5 c0,0,0,0,0,0l0.8,1.9c1.6,0.8,2.9,1.1,4,1.1c0.7,0,1.5-0.2,2.6-0.7l0,0c1-0.4,2.2,0.1,2.6,1.1 C296.1,223.7,296.1,223.8,296.1,223.8L296.1,223.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178182171276766277430000005484732682423193988_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091708321662076898740000014340713045811718576_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178182171276766277430000005484732682423193988_)"
    }
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178194281415903083720000002672899346186257288_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050655230330433067390000005432798271815716014_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178194281415903083720000002672899346186257288_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 218.5,
    style: {
      clipPath: "url(#SVGID_00000050655230330433067390000005432798271815716014_)",
      fill: "#E4E4E4"
    },
    width: 34.7,
    height: 13.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000056425300632570645780000010218619408278281631_",
    d: "M243.8,223.8c0.4,1.2,0.6,2.1,0.6,2.8 c0,1-0.2,2.5-0.5,4.4c-1.2,0-11.6,0-31.4,0c-0.8-2.7-0.3-4.2,1.4-4.4c1.8-0.2,3.2-0.4,4.4-0.6l14.2-6.3c0.5-0.2,1.1,0,1.3,0.5 c0,0,0,0,0,0l0.8,1.9c1.6,0.8,2.9,1.1,4,1.1c0.7,0,1.5-0.2,2.6-0.7l0,0c1-0.4,2.2,0.1,2.6,1.1 C243.7,223.7,243.7,223.8,243.8,223.8L243.8,223.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120553293984517053460000006448685099876889235_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056425300632570645780000010218619408278281631_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120553293984517053460000006448685099876889235_)"
    }
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000177468654805648719300000005783600009092370315_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124843893275772088470000005446499520417005453_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177468654805648719300000005783600009092370315_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 210.6,
    y: 218.5,
    style: {
      clipPath: "url(#SVGID_00000124843893275772088470000005446499520417005453_)",
      fill: "#E4E4E4"
    },
    width: 34.7,
    height: 13.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000002385176371148926920000002934404829735399081_",
    points: "275.5,98 266.6,132.9 239.4,132.9 243.5,98  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098933369124515501890000003241959173804744367_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002385176371148926920000002934404829735399081_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098933369124515501890000003241959173804744367_)"
    }
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142855250456875758380000012083948343618909371_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044140802493110061030000014029753533168760457_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142855250456875758380000012083948343618909371_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 238.4,
    y: 97,
    style: {
      clipPath: "url(#SVGID_00000044140802493110061030000014029753533168760457_)",
      fill: "#69A1AC"
    },
    width: 38.1,
    height: 36.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000036235300132250318420000011216430867399578523_",
    d: "M280.5,98c2.9,8.8,3.5,20.4,1.7,34.9h-27.8L246.8,98 H280.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080206204842419440560000000465943483968470185_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036235300132250318420000011216430867399578523_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080206204842419440560000000465943483968470185_)"
    }
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176736174541529055670000016578098672889786265_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104690381714546886210000003311027689220206727_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176736174541529055670000016578098672889786265_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 245.8,
    y: 97,
    style: {
      clipPath: "url(#SVGID_00000104690381714546886210000003311027689220206727_)",
      fill: "#89C5CC"
    },
    width: 39.2,
    height: 36.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000101061047211011453230000003191680442794272645_",
    d: "M212.7,48.5c1.6,2.8,3.1,5.9,2.3,6.7 c-0.8,0.9-2.8-0.3-3.8,1.1c-0.6,1,2.8,2.5,10.3,4.6L235.9,74l7.3-7.8l-19.7-10.8c-3.3-3.9-6.5-6.9-9.7-9.1 C212.9,46,211.2,45.7,212.7,48.5z M197.9,68.3c-2.5-0.5-8.4-5-9.5-4.1c-1.5,1.3-0.2,5.5,1.4,7.5c3,3.8,5.5,5.1,11.6,6.8 c3.2,0.9,6.7,2.7,10.4,5.4l0.5-8.7l-8.6-4.7c-1.2-4.6-2.7-6.9-4.3-7C198.1,63,200.3,68.8,197.9,68.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014593823094858244400000015160472312732974521_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101061047211011453230000003191680442794272645_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014593823094858244400000015160472312732974521_)"
    }
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132078533296406372260000007787044321528740484_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148657023481209325610000004577833755326641024_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132078533296406372260000007787044321528740484_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 44.7,
    style: {
      clipPath: "url(#SVGID_00000148657023481209325610000004577833755326641024_)",
      fill: "#997659"
    },
    width: 58.1,
    height: 40.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003086392714831316940000003663052538623583371_",
    d: "M252.7,63.8c-6.9-0.1-16.1-1.5-25.9-7.8l-3.8,8.6 c6.8,6.7,16.3,12.2,24.6,12C254.1,76.4,257.5,68.5,252.7,63.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086672575743319910260000012675422715724842375_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003086392714831316940000003663052538623583371_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000086672575743319910260000012675422715724842375_)"
    }
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000096054875577606367610000006390583317052898212_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147202242226469852990000001326618259319143605_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096054875577606367610000006390583317052898212_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 46.8,
    transform: "matrix(0.1564 -0.9877 0.9877 0.1564 137.0168 293.3437)",
    style: {
      clipPath: "url(#SVGID_00000147202242226469852990000001326618259319143605_)",
      fill: "#2026A2"
    },
    width: 28,
    height: 39.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000007429988912598908270000003743010445616956575_",
    d: "M252.3,42c-0.7,8.4-3.3,17.4-6.1,26.6l-0.5,1.6 c-0.1,0.3-0.2,0.5-0.2,0.8l-0.5,1.6c-0.5,1.7-1,3.3-1.5,5c-7.3,1.8-19.6-0.3-36.8-6.5c-4.3,8.8-6.2,15.1-5.9,18.9 c14.8,7.7,27.4,11.2,37.8,11.4c-0.3,6.2,0.4,12.1,2.9,17.5c3,6.3,14.1,5.7,25.1,4.4l1.2-0.1c7.9-1,15.5-2.2,19.6-1.4 c4-12.9,0.7-21.1-2.3-28.6l-0.3-0.7l-0.3-0.7c-1.6-4.1-3.1-8.1-3.1-12.6c0-14.6-11.7-37.1-13.4-37.1H252.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036252244522975822220000015282981774942401424_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007429988912598908270000003743010445616956575_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036252244522975822220000015282981774942401424_)"
    }
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000016776959505204712740000007140467499522981804_",
    x: 187,
    width: 110,
    height: 231
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117634184431454652760000001495993420283410824_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016776959505204712740000007140467499522981804_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.4,
    y: 41,
    style: {
      clipPath: "url(#SVGID_00000117634184431454652760000001495993420283410824_)",
      fill: "#1F28CF"
    },
    width: 93,
    height: 85.2
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000056428026193558005310000003518523956349925543_",
    d: "M326.9,152.9c4-0.2,8.9,2.1,9.4,6.5 c0.3,3.2,0.2,6.3,0.7,9.5c0.4,2.5,1.2,5,2.3,7.3c1.1,2.2,3.3,4.1,3.8,6.5c0.4,1.5,0.2,3.6-0.3,5.1c-0.6,1.8-0.3,1.7,0.9,3.2 c2.4,2.9,4.6,6,6.1,9.5c2.2,5.1,3.6,11,2.8,16.6c-0.1,0.7-0.2,3.2-1.2,3.4c-1.1,0.2-0.6-1.2-0.5-1.7c0.4-3,0.7-5.6,0.3-8.6 c-1.7-11.7-10.1-19.4-15.5-29.3c-0.3-0.5-0.9-1.7-1.4-2.5c-0.7-1.3-1.4-3.7-2.3-4.6c-1.8-1.8-0.1,1.8,0.2,2.5 c0.4,0.9,0.9,1.8,1.4,2.5c2,3.5,4.3,7.3,6.4,10.9c-9.1,2.1-15.5-8.9-18-16.1C319.9,167.3,317.5,153.4,326.9,152.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132056807661941929170000018050704330837434006_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000056428026193558005310000003518523956349925543_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132056807661941929170000018050704330837434006_)"
    }
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062182487816708333130000007477344555975455146_",
    x: 318,
    y: 119,
    width: 76,
    height: 118
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181052249907562769310000006186440493255084180_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062182487816708333130000007477344555975455146_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 313.6,
    y: 150,
    transform: "matrix(0.9945 -0.1045 0.1045 0.9945 -17.6665 36.1138)",
    style: {
      clipPath: "url(#SVGID_00000181052249907562769310000006186440493255084180_)",
      fill: "#69A1AC"
    },
    width: 44.3,
    height: 73.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150076577420394743240000008908031458165833614_",
    d: "M380.1,142c-6.7,0.5-11,4.9-13,11.1 c-1.1,3.3-1.2,6.7-1.8,10.1c-0.9,5.1-2.9,9-6.7,12.7c-1.2,1.1-2,2.3-2.7,3.5c-1.2,1.2-2.3,2.6-3.1,4.4c-1,2.2-1.3,4.8-0.1,7 c0.3,0.6,1.1,1.8,1.9,2.3c-3,6.4-4.7,13.3-4.5,20.3c0.1,4.2,0.3,8.4,0.6,12.6c0.1,1.1,0.4,3,1,1.1c0.5-1.7-0.1-4.4-0.2-6.2 c-0.3-8.8-0.5-16.8,3.1-25c0.4-0.9,0.8-1.7,1.2-2.6c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.5 c0.3-0.4,0.7-1,0.7-1.3c0,0,0,0,0,0c2.3-3.7,4.8-7.1,7.5-10.5c0,0,2.9-3.9,2.4-1.7c-0.2,1-2.3,3-3.2,4.1 c-1.9,2.4-4.1,5.6-6,8.6c-0.2,0.1-0.6,0.8-0.9,1.4c-0.1,0.3-0.3,0.5-0.4,0.8c6.6,2.2,11.7-2.2,15.1-7.2c0,0,0,0,0,0 c1.1-1.4,2.1-2.8,3.5-3.9c2.3-1.8,4.7-2.2,7.3-3.1c7.3-2.5,10.4-11.8,11.3-18.8C395,153.3,389.6,141.3,380.1,142"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057140014449871251680000010379052708583556737_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150076577420394743240000008908031458165833614_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057140014449871251680000010379052708583556737_)"
    }
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023272393589738031470000008255066291731122819_",
    x: 318,
    y: 119,
    width: 76,
    height: 118
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148622243523961067740000000187846067991264425_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023272393589738031470000008255066291731122819_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 348.9,
    y: 140.3,
    style: {
      clipPath: "url(#SVGID_00000148622243523961067740000000187846067991264425_)",
      fill: "#89C5CC"
    },
    width: 46.1,
    height: 89.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000028311176885936394540000015870876728562521514_",
    d: "M367.3,119.8c-6.9,7.2-10.2,17.1-12.8,26.4 c-2.9,10.4-4.9,21-4.9,31.9c0,7.1-0.2,14.3,0.2,21.4c0.1,2.5,0.4,5.1,0.8,7.6c0,0.2,0.9,5.8,1.8,4.5c0.5-0.7-0.9-5.8-1-6.6 c-0.6-4.7-0.7-9.5-0.7-14.3c0-7.9-0.2-15.7,0.6-23.5c0.1-1.2,0.2-2.4,0.5-3.5c0.3-1.2-0.1-0.7,0.9-1.2c0.9-0.5,2.1-0.4,3-1 c3.8-2.3,5.8-8.3,7.3-12.2c1.7-4.5,2.8-9.3,3.7-14c0.6-3.5,1.1-6.9,1.3-10.4c0.1-1.1,0.1-2.3,0.3-3.4c0.1-0.3,0.4-0.8,0.3-1.1 c0-0.6-0.4-0.9-0.4-1.3C367.9,119.3,367.6,119.6,367.3,119.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026876199721684544500000009265136251919929779_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000028311176885936394540000015870876728562521514_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026876199721684544500000009265136251919929779_)"
    }
  }, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000057112166840225575780000011614382912103716497_",
    x: 318,
    y: 119,
    width: 76,
    height: 118
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107578644368532349060000003225792638062186896_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057112166840225575780000011614382912103716497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 341.9,
    y: 117.1,
    transform: "matrix(0.9903 -0.1392 0.1392 0.9903 -19.6043 51.5691)",
    style: {
      clipPath: "url(#SVGID_00000107578644368532349060000003225792638062186896_)",
      fill: "#89C5CC"
    },
    width: 34.1,
    height: 97.6
  }))), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000051356853365098255010000014985395516744242841_",
    d: "M330.2,216c0,11.6,9.6,21,21.4,21 c11.8,0,21.4-9.4,21.4-21"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034808537894965533990000010174871712883208625_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051356853365098255010000014985395516744242841_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034808537894965533990000010174871712883208625_)"
    }
  }, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000040540095782221869510000017664608023541625492_",
    x: 318,
    y: 119,
    width: 76,
    height: 118
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125561001094296544050000000158120552381992601_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040540095782221869510000017664608023541625492_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 329.2,
    y: 215,
    style: {
      clipPath: "url(#SVGID_00000125561001094296544050000000158120552381992601_)",
      fill: "#89C5CC"
    },
    width: 44.9,
    height: 23
  }))), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000033338587469563106760000012462376144388805552_",
    d: "M366,196c5.2-0.4,11.1,3.9,13.6,8.4 c2,3.6,1.7,8.4,0.4,12.2c-0.8,2.6-2.7,6.3-5.7,6.3c-3.8,0-4-4.8-4.1-7.6c-0.1-3.8-0.6-7.1-3.5-9.6c-0.7-0.6-1.4-1.1-2.1-1.7 c-1.1-0.9-2.2-1.9-2.4-3.4c-0.2-2.1,1-2.5,2.7-2.1c0.3,0.1,3.3,1.5,2.9,0.4c-0.1-0.3-0.6-0.6-1.3-0.8 c-1.6-0.2-3.6-0.4-4.2-0.3c-6.1,1.4-8.4,10-9.1,15.5c-0.1,0.6-0.1,1.2-0.2,1.8l-1.1,0c0.1-1.4,0.2-2.9,0.4-4.3 c0.9-5.4,3.7-13.4,9.8-14.3c0.2,0,1.1,0,2.1,0C364.9,196.2,365.4,196.1,366,196z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172440636185011283470000011174415717842960567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000033338587469563106760000012462376144388805552_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000172440636185011283470000011174415717842960567_)"
    }
  }, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000141444594461216811190000005777775028990289302_",
    x: 318,
    y: 119,
    width: 76,
    height: 118
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103946261145645938220000002321292350674465935_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141444594461216811190000005777775028990289302_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 351.1,
    y: 194.6,
    style: {
      clipPath: "url(#SVGID_00000103946261145645938220000002321292350674465935_)",
      fill: "#69A1AC"
    },
    width: 31.5,
    height: 29.4
  })))))), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178885558798079653310000007314259180946273671_",
    d: "M133.4,198.5c0,21.3,1.7,38.5,24.2,38.5 c22.5,0,24.2-17.3,24.2-38.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118362740953941511390000015394850614407057804_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178885558798079653310000007314259180946273671_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118362740953941511390000015394850614407057804_)"
    }
  }, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000120530338062387266960000012892637289220092060_",
    x: -1450,
    y: -193,
    width: 1920,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171704454820730467590000003628515447617376953_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000120530338062387266960000012892637289220092060_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 132.4,
    y: 197.5,
    style: {
      clipPath: "url(#SVGID_00000171704454820730467590000003628515447617376953_)",
      fill: "#F2F2F2"
    },
    width: 50.5,
    height: 40.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005974828753352741540000000560733203526133397_",
    d: "M164.4,185.2c-0.8,1.4-1.6,2.9-2.2,4.4 c0-3,0.1-6.1,0.6-9.2c0.8-5.3,2-10.6,3.1-15.9c0.8-3.8,0.8-10.6,3.8-13.7c0.8-0.7,1,0.6,1,1.2c0,0.1,0-2.3-0.8-1.9 c-4.9,2.5-6.4,10.4-8,14.4c-2.3,5.8-4.2,11.7-5,17.7c-0.2,1.5-0.3,3-0.3,4.6c-0.2-0.4-0.3-0.8-0.5-1.2c-2.8-6.6-6.6-13-11.3-19 c-1.2-1.5-15.8-15.9-17-13.7c0.1,0.3,0.3,0.6,0.7,0.8c0,0,0,0,0,0c0.9,1.4,3.3,3.5,4.1,4.8c1.9,3.1,3.4,6.3,4.9,9.5 c3.2,6.7,6.2,13.5,9,20.4c0.7,1.6,1.4,3.2,2.1,4.7c-7.3-10.6-17.1-20.2-30.6-25.7c4.6,2.3,7.6,6.8,10.7,10.1 c3.8,4.1,7.7,8,11.5,12.1c4.4,4.8,9.6,9.8,13.9,15.2c4.1,8.7,8.1,17.3,10.6,26.5c-1-3.1-0.1-7.5-0.3-10.8 c-0.1-2.6-0.4-5.2-0.9-7.8c0.5,1.2,1,2.3,1.2,3.4c-0.2-1.8-0.4-3.7-0.6-5.5c0.6-1.7,1.2-3.3,1.6-4.6c2-6.7,4.4-13.3,7.6-19.7 c3-5.9,6.5-11.8,10.2-17.5c1.8-2.6,3.5-5.3,5.3-7.9c1.2-1.7,2.3-4.5,3.9-6.2C182.3,164.2,171,173.8,164.4,185.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041281193283276623250000010602917213014084271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005974828753352741540000000560733203526133397_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041281193283276623250000010602917213014084271_)"
    }
  }, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003811624338800655400000008879376272664293305_",
    x: -1450,
    y: -193,
    width: 1920,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146499518102906551340000010699912108902071454_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003811624338800655400000008879376272664293305_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 148.6,
    style: {
      clipPath: "url(#SVGID_00000146499518102906551340000010699912108902071454_)",
      fill: "#F2F2F2"
    },
    width: 76.7,
    height: 83.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.be643f88dc10bc414840cb68455e7f39.svg";
export { ForwardRef as ReactComponent };